function Categories() {
  return <h1>Categories Page</h1>;
}

export default Categories;